const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UPPERCASE_RE = /[A-Z]/;
const LOWERCASE_RE = /[a-z]/;
const NUMBER_RE = /\d/;
const SPECIAL_RE = /[^A-Za-z0-9]/;
const PHONE_RE = /^\+\d{8,15}$/;

const trimVisible = (value = "") => value.trim();

const isValidDateString = (value) => {
  if (!value) return false;
  const date = new Date(value);
  return !Number.isNaN(date.getTime());
};

export const getPasswordChecks = (password = "") => ({
  minLength: password.length >= 8,
  uppercase: UPPERCASE_RE.test(password),
  lowercase: LOWERCASE_RE.test(password),
  number: NUMBER_RE.test(password),
  special: SPECIAL_RE.test(password),
});

export const normalizeRegistrationPayload = (formData, mode = "classic") => {
  const payload = {
    firstname: trimVisible(formData.firstname),
    lastname: trimVisible(formData.lastname),
    email: trimVisible(formData.email).toLowerCase(),
    phone: formData.phone,
    civility: formData.civility || null,
    birthdate: formData.birthdate || null,
  };

  if (mode === "classic") {
    payload.password = formData.password;
    payload.confirmPassword = formData.confirmPassword;
  }

  if (mode === "social" && formData.token) payload.token = formData.token;
  if (mode === "social" && formData.provider) payload.provider = formData.provider;
  if (formData.google_token) payload.google_token = formData.google_token;
  if (formData.fcm_token) payload.fcm_token = formData.fcm_token;
  if (formData.is_new != null) payload.is_new = formData.is_new;

  return payload;
};

export const validateRegistration = (values, mode = "classic", t) => {
  const errors = {};
  const firstname = trimVisible(values.firstname);
  const lastname = trimVisible(values.lastname);
  const email = trimVisible(values.email);
  const birthdate = values.birthdate;
  const civility = values.civility;
  const passwordChecks = getPasswordChecks(values.password);

  if (!firstname) {
    errors.firstname = t("register.errors.firstNameRequired");
  } else if (firstname.length < 2) {
    errors.firstname = t("register.errors.firstNameMin");
  } else if (firstname.length > 150) {
    errors.firstname = t("register.errors.firstNameMax");
  }

  if (!lastname) {
    errors.lastname = t("register.errors.lastNameRequired");
  } else if (lastname.length < 2) {
    errors.lastname = t("register.errors.lastNameMin");
  } else if (lastname.length > 150) {
    errors.lastname = t("register.errors.lastNameMax");
  }

  if (!email) {
    errors.email = t("register.errors.emailRequired");
  } else if (!EMAIL_RE.test(email)) {
    errors.email = t("register.errors.emailInvalid");
  }

  const normalizedPhone = (values.phone || "").replace(/[\s()-]/g, "");

  if (!values.phone) {
    errors.phone = t("register.errors.phoneRequired");
  } else if (!PHONE_RE.test(normalizedPhone)) {
    errors.phone = t("register.errors.phoneInvalid");
  }

  if (birthdate) {
    if (!isValidDateString(birthdate)) {
      errors.birthdate = t("register.errors.birthdateInvalid");
    } else {
      const selected = new Date(birthdate);
      const today = new Date();
      selected.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (selected > today) {
        errors.birthdate = t("register.errors.birthdateFuture");
      }
    }
  }

  if (civility && !["MR", "MS"].includes(civility)) {
    errors.civility = t("register.errors.civilityInvalid");
  }

  if (mode === "classic") {
    if (!values.password) {
      errors.password = t("register.errors.passwordRequired");
    } else if (
      !passwordChecks.minLength ||
      !passwordChecks.uppercase ||
      !passwordChecks.lowercase ||
      !passwordChecks.number ||
      !passwordChecks.special
    ) {
      errors.password = t("register.errors.passwordWeak");
    }

    if (!values.confirmPassword) {
      errors.confirmPassword = t("register.errors.confirmPasswordRequired");
    } else if (values.confirmPassword !== values.password) {
      errors.confirmPassword = t("register.errors.confirmPasswordMismatch");
    }
  }

  if (!values.acceptCGU) {
    errors.acceptCGU = t("register.errors.termsRequired");
  }

  return errors;
};
